import { FC, ReactNode } from 'react';
import { Typography, Grid } from '@mui/material';

interface Props {
  title: string;
  adornment?: ReactNode;
}

export const SubTitle: FC<Props> = ({ title, adornment }) => {
  return (
    <Grid container bgcolor="primary.lighter" sx={{ height: '60px', paddingX: '20px' }} justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="subtitle1" noWrap={true}>
          {title}
        </Typography>
      </Grid>
      {adornment && <Grid item>{adornment}</Grid>}
    </Grid>
  );
};
